// Lightweight reusable video play/pause controller for Media-with-text section
// Binds buttons with class `.rm-video-pp` inside `.mwt-video` to the sibling <video>
(function () {
  'use strict';

  function sync(btn, video) {
    if (!btn || !video) return;
    if (video.paused || video.ended) {
      btn.classList.add('play');
      btn.classList.remove('pause');
    } else {
      btn.classList.add('pause');
      btn.classList.remove('play');
    }
  }

  function initInScope(scope) {
    var root = scope || document;
    var buttons = root.querySelectorAll('.mwt-video .rm-video-pp, .rich-text__video .rm-video-pp');
    if (!buttons || !buttons.length) return;
    buttons.forEach(function (btn) {
      if (btn.dataset.ppInit === '1') return;
      var container = btn.closest('.mwt-video') || btn.closest('.rich-text__video') || btn.parentElement;
      if (!container) return;
      var video = container.querySelector('video.mwt-video-el, .mwt-video-el');
      if (!video) video = container.querySelector('video');
      if (!video) return;

      btn.dataset.ppInit = '1';
      video.setAttribute('playsinline', '');
      video.muted = true;

      var syncBound = sync.bind(null, btn, video);
      video.addEventListener('play', syncBound);
      video.addEventListener('pause', syncBound);
      setTimeout(syncBound, 100);

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        try {
          if (video.paused) {
            var p = video.play();
            if (p && typeof p.then === 'function') {
              p.catch(function () {});
            }
          } else {
            video.pause();
          }
        } catch (err) {}
      });
    });

    var containers = root.querySelectorAll('.mwt-video, .rich-text__video');
    containers.forEach(function (container) {
      if (container.dataset.ioInit === '1') return;
      var vid = container.querySelector('video.mwt-video-el, .mwt-video-el');
      if (!vid) vid = container.querySelector('video');
      if (!vid) return;
      var shouldAutoplay = (container.dataset.autoplay || '').toString() === 'true';
      if (!shouldAutoplay) return;

      container.dataset.ioInit = '1';
      vid.setAttribute('playsinline', '');
      vid.muted = true;

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            try {
              var pr = vid.play();
              if (pr && typeof pr.then === 'function') {
                pr.catch(function () {});
              }
            } catch (e) {}
          } else {
            vid.pause();
          }
        });
      }, { threshold: 0.6, rootMargin: '0px 0px -10% 0px' });

      observer.observe(container);
      // Store so it can be GC'd with the element
      container._mwtObserver = observer;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initInScope(document);
    });
  } else {
    initInScope(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (!e || !e.target) return;
    initInScope(e.target);
  });
  document.addEventListener('shopify:block:select', function (e) {
    if (!e || !e.target) return;
    initInScope(e.target);
  });
})(); 

// Quick View overlay: show on image tap for touch devices
(function () {
  'use strict';

  function isTouchPreferred() {
    if (window.matchMedia) {
      try {
        if (window.matchMedia('(hover: none)').matches) return true;
        if (window.matchMedia('(pointer: coarse)').matches) return true;
      } catch (e) {}
    }
    return 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  }

  function initTapOverlay(scope) {
    var root = scope || document;
    var overlays = root.querySelectorAll('.card-wrapper .qv-overlay');
    if (!overlays.length) return;

    overlays.forEach(function (overlay) {
      var card = overlay.closest('.card-wrapper');
      if (!card || card.dataset.qvInit === '1') return;
      var media = card.querySelector('.card__media, .card__inner .media');
      if (!media) return;

      card.dataset.qvInit = '1';

      // Toggle class on media tap
      media.addEventListener('click', function (e) {
        if (!isTouchPreferred()) return;
        e.preventDefault();
        e.stopPropagation();
        // Close any other open cards
        document.querySelectorAll('.card-wrapper.qv-open').forEach(function (el) {
          if (el !== card) el.classList.remove('qv-open');
        });
        card.classList.toggle('qv-open');
      });

      // Prevent clicks inside overlay from closing immediately
      overlay.addEventListener('click', function (e) {
        e.stopPropagation();
      });
    });

    // Global click to close when tapping outside
    document.addEventListener('click', function () {
      if (!isTouchPreferred()) return;
      document.querySelectorAll('.card-wrapper.qv-open').forEach(function (el) {
        el.classList.remove('qv-open');
      });
    });

    // Escape key closes any open overlays
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        document.querySelectorAll('.card-wrapper.qv-open').forEach(function (el) {
          el.classList.remove('qv-open');
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initTapOverlay(document);
    });
  } else {
    initTapOverlay(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (!e || !e.target) return;
    initTapOverlay(e.target);
  });
})();
